import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkspaces = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.99992 14C3.26659 14 2.63881 13.7389 2.11659 13.2167C1.59436 12.6944 1.33325 12.0667 1.33325 11.3333C1.33325 10.6 1.59436 9.97222 2.11659 9.45C2.63881 8.92778 3.26659 8.66667 3.99992 8.66667C4.73325 8.66667 5.36103 8.92778 5.88325 9.45C6.40547 9.97222 6.66659 10.6 6.66659 11.3333C6.66659 12.0667 6.40547 12.6944 5.88325 13.2167C5.36103 13.7389 4.73325 14 3.99992 14ZM11.9999 14C11.2666 14 10.6388 13.7389 10.1166 13.2167C9.59436 12.6944 9.33325 12.0667 9.33325 11.3333C9.33325 10.6 9.59436 9.97222 10.1166 9.45C10.6388 8.92778 11.2666 8.66667 11.9999 8.66667C12.7333 8.66667 13.361 8.92778 13.8833 9.45C14.4055 9.97222 14.6666 10.6 14.6666 11.3333C14.6666 12.0667 14.4055 12.6944 13.8833 13.2167C13.361 13.7389 12.7333 14 11.9999 14ZM7.99992 7.33333C7.26659 7.33333 6.63881 7.07222 6.11659 6.55C5.59436 6.02778 5.33325 5.4 5.33325 4.66667C5.33325 3.93333 5.59436 3.30556 6.11659 2.78333C6.63881 2.26111 7.26659 2 7.99992 2C8.73325 2 9.36103 2.26111 9.88325 2.78333C10.4055 3.30556 10.6666 3.93333 10.6666 4.66667C10.6666 5.4 10.4055 6.02778 9.88325 6.55C9.36103 7.07222 8.73325 7.33333 7.99992 7.33333Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgWorkspaces);
export default ForwardRef;
